var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 8.70834H7.125L9.72958 6.10375C9.80379 6.03016 9.86268 5.9426 9.90287 5.84613C9.94306 5.74965 9.96376 5.64618 9.96376 5.54167C9.96376 5.43716 9.94306 5.33368 9.90287 5.23721C9.86268 5.14074 9.80379 5.05318 9.72958 4.97959C9.58125 4.83214 9.38061 4.74937 9.17146 4.74937C8.96231 4.74937 8.76166 4.83214 8.61333 4.97959L5.21708 8.38375C4.91974 8.67932 4.75177 9.08075 4.75 9.5C4.75385 9.9165 4.92167 10.3147 5.21708 10.6083L8.61333 14.0125C8.68715 14.0858 8.77467 14.1438 8.87092 14.1833C8.96716 14.2228 9.07024 14.2429 9.17426 14.2425C9.27828 14.2422 9.38121 14.2213 9.47717 14.1812C9.57313 14.141 9.66025 14.0824 9.73354 14.0085C9.80684 13.9347 9.86487 13.8472 9.90434 13.751C9.94381 13.6547 9.96393 13.5516 9.96357 13.4476C9.9632 13.3436 9.94235 13.2407 9.9022 13.1447C9.86205 13.0487 9.8034 12.9616 9.72958 12.8883L7.125 10.2917H15.0417C15.2516 10.2917 15.453 10.2083 15.6015 10.0598C15.7499 9.91133 15.8333 9.70997 15.8333 9.5C15.8333 9.29004 15.7499 9.08868 15.6015 8.94021C15.453 8.79174 15.2516 8.70834 15.0417 8.70834Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.138cb79106d0e974a98f4d812dc2974c.svg";
export { ForwardRef as ReactComponent };